export class InterIntegrationConfig {
    id: number
    clientSecret: string
    clientId: string
    accountNumber: number
    accountNumberVd: string
    account: number
    paymentMethodName: string
    keyUrl: string
    crtUrl: string
    webhookRegistered: boolean
}
